import styled from "styled-components";

import { alpha } from "../../../typography";

import { AllIconName, Icon, IconType } from "../../Icon";

import { SquareDotLoadingIndicator } from "../../Loader";

const TitleRow = styled.header<{ bgColor: string }>`
  width: fit-content;
  flex-grow: 0;
  display: flex;
  align-items: center;
  background-color: ${({ bgColor }) =>
    bgColor}; /* will be used in the future with a proper definition from design */

  h2 {
    flex-grow: 1;
    margin: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${alpha.primaryActive.headline3};
  }

  > span {
    display: block;
    :first-child {
      margin-right: 8px;
    }
  }

  .loader-icon-square {
    margin-right: 15px;
  }
`;

type TitleProps = {
  /** The title content to render. */
  children: string;

  /** An optional icon to render with the title. */
  iconName?: AllIconName;

  /** The Type of the icon to render with the title. */
  iconType?: IconType;

  /** Variant indicating the background color of the title. */
  bgColor?: "PRIMARY" | "SECONDARY" | "ERROR" | "WARNING" | "SUCCESS";

  /** Title id. */
  titleId?: string;

  hasLoader?: boolean;
};

export const Title = ({
  children,
  iconName,
  iconType,
  bgColor,
  titleId,
  hasLoader,
}: TitleProps) => {
  const bgColorStyle = {
    ["PRIMARY"]: "var(--color-primary-500)",
    ["SECONDARY"]: "var(--color-secondary-800)",
    ["ERROR"]: "var(--color-error-500)",
    ["WARNING"]: "var(--color-warning-500)",
    ["SUCCESS"]: "var(--color-success-500)",
    ["NEUTRAL"]: "--color-neutral-000-full",
  }; // pending to be defined. will be used in the future with a proper definition from design

  return (
    <TitleRow
      id={titleId}
      bgColor={bgColor ? bgColorStyle[bgColor] : bgColorStyle["NEUTRAL"]}
    >
      {iconName && (
        <Icon iconSize={"regular"} iconName={iconName} plain type={iconType} />
      )}
      {hasLoader && <SquareDotLoadingIndicator speed={1} />}
      <h2>{children}</h2>
    </TitleRow>
  );
};
